export const MODELS = {
  contact: 'contact',
  referral: 'referrals_referral',
  servicecase: 'cases_servicecase',
};

export const MEDICAID_ID_LABEL = 'Medicaid ID';
export const EXTERNAL_ID_LABEL = 'External ID';
export const CLIENT_NAME_SCOPE = 'client_name';
export const MEDICAID_ID_SCOPE = 'medicaid_id';
export const SEARCH_SCOPES = [
  {
    label: 'Client Name',
    value: CLIENT_NAME_SCOPE,
  },
  {
    label: MEDICAID_ID_LABEL,
    value: MEDICAID_ID_SCOPE,
  },
];

export const CLIENT_RESULTS_COUNT = 12;
export const DEFAULT_INDEX_COUNT = 20;
export const DEFAULT_RECORD_TYPE = MODELS.contact;
export const DEFAULT_VIEW_OPTION = MODELS.contact;
export const DEFAULT_SEARCH_SCOPE = CLIENT_NAME_SCOPE;
export const NO_RESULTS_FOUND_TEXT = 'No results found';
export const SEARCH_FAILED_TEXT = 'Search failed. Please try again.';
export const MIN_CHAR_WARNING_TEXT = 'Use three characters or more to search.';
export const VIEW_OPTIONS = [
  { label: 'Clients', value: MODELS.contact },
  { label: 'Referrals', value: MODELS.referral },
  { label: 'Cases', value: MODELS.servicecase },
];
export const MIN_CHAR_COUNT_FOR_SEARCH = 3;
export const MAX_CHAR_COUNT_FOR_SEARCH = 70;
export const SEARCH_SCOPE_SESSION_STORAGE_KEY = 'client-list-search-scope';
export const SEARCH_DEBOUNCE_TIME = 500;
